/* ------------------------------------------ gfShortcut 02/2020 ----------------------------------------- */
/**
 * This module register shortcut listeners, allow users to use keyboard shortcuts to trigger some functionalities.
 */
import { app } from '@/store';
import { mutations } from '@modules/libraries/store/types';
import { checkKeyValid } from '@/app/utils/checkRoleApply';

(function (jQuery) {
  jQuery.gfShortcut = function (element, options) {
    const defaults = {};

    this.settings = {};
    const $element = jQuery(element);

    /* Editor */
    const $divTopBar = jQuery('#divTopBar');
    const $shopLaunch = jQuery('#shopLaunch');
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();

    const _this = this;
    let pressedKeys = new Map();
    let keyboards = [];
    const KEY_CODES = {
      Ctrl: 17, //Mac (Control) + Win
      Command: 91, //Mac = Meta Key
      OptionAlt: 18, //Mac = Alt in Win
      Shift: 16,
      Esc: 27,
      Z: 90,
      C: 67,
      V: 86,
      D: 68,
      Delete: 46,
      B: 66,
      I: 73,
      U: 85,
      S: 83,
      L: 76,
      '/': 191,
    };

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      _this.registerShortcuts();
    };

    this.registerShortcuts = function () {
      $element.keydown(function (e) {
        if (!_this.hasUsingKeyboardShortcut(e)) {
          return;
        }
        if (_this.checkIsInputting()) {
          return;
        }
        if (_this.blockKeyboardBrowser(e)) {
          e.preventDefault();
        }
        pressedKeys.set(e.which, true);
        _this.handleShortcut();
        if (e.metaKey) {
          pressedKeys = new Map();
          _this.checkShortcut(e);
        }
      });

      $element.keyup(function (e) {
        if (!_this.hasUsingKeyboardShortcut(e)) {
          return;
        }
        if (_this.checkIsInputting()) {
          return;
        }
        pressedKeys = new Map();
        _this.checkShortcut(e);
      });
    };
    this.handleShortcut = function () {
      keyboards = [];
      for (const [key, value] of pressedKeys) {
        if (!value) continue;
        keyboards.push(parseInt(key));
      }
      return false;
    };

    this.checkShortcut = function (e) {
      const validShort = _this.validateShortcuts(e);
      if (!validShort) {
        return false;
      }
      // Esc (Quit / Back)
      if (this.hasKeyboard(keyboards, 'Esc')) {
        this.helperCheckAndHandleShortcut();
        this.resetKeyboard();
        return false;
      }
      const isHasPopupOpen = this.helperCheckAndHandleShortcut(true, true);

      // Delete (Delete)
      if (this.hasKeyboard(keyboards, 'Delete')) {
        const isEditingText = $gryffEditor.find('.text-editing').length > 0
        if (isHasPopupOpen || isEditingText) {
          return;
        }
        const keyType = 'DELETE';
        $gryffEditor.trigger('handleshortcut.element', [keyType]);
        this.resetKeyboard();
        return false;
      }
      // Keep Ctrl || Command
      if (this.hasKeyboard(keyboards, 'Ctrl') || this.hasKeyboard(keyboards, 'Command')) {
        if (isHasPopupOpen) {
          return;
        }
        // Ctrl + Shift
        if (this.hasKeyboard(keyboards, 'Shift')) {
          // Ctrl + Shift + Z (Redo)
          if (this.hasKeyboard(keyboards, 'Z')) {
            $divTopBar.find('.gf_history-item[data-action="redo"]', parent.document).trigger('mousedown.undoandredo');
            this.resetKeyboard();
            return false;
          }

          // Ctrl + Shift + S (Save & Publish)
          if (this.hasKeyboard(keyboards, 'S')) {
            $gryffEditor.data('gryffeditor').handlePublishNow();
            this.resetKeyboard();
            return false;
          }
        }
        // Ctrl + Alt || Ctrl + Option
        if (this.hasKeyboard(keyboards, 'OptionAlt')) {
          // Ctrl + Alt + C (Copy Style)
          if (this.hasKeyboard(keyboards, 'C')) {
            const keyType = 'COPY_CSS';
            $gryffEditor.trigger('handleshortcut.element', [keyType]);
            this.resetKeyboard();
            return false;
          }

          // Ctrl + Alt + V (Paste Style)
          if (this.hasKeyboard(keyboards, 'V')) {
            const keyType = 'PASTE_CSS';
            $gryffEditor.trigger('handleshortcut.element', [keyType]);
            this.resetKeyboard();
            return false;
          }
        }
        // Ctrl + B (Bold Text)
        if (this.hasKeyboard(keyboards, 'B')) {
          const $mdEditorLink = jQuery('#md-text-editor');
          $mdEditorLink.find('a[data-cmd="bold"]').trigger('click');
          this.resetKeyboard();
          return false;
        }
        // Ctrl + I (Italic Text)
        if (this.hasKeyboard(keyboards, 'I')) {
          const $mdEditorLink = jQuery('#md-text-editor');
          $mdEditorLink.find('a[data-cmd="italic"]').trigger('click.open');
          this.resetKeyboard();
          return false;
        }
        // Ctrl + U (Underline Text)
        if (this.hasKeyboard(keyboards, 'U')) {
          const $mdEditorLink = jQuery('#md-text-editor');
          $mdEditorLink.find('a[data-cmd="underline"]').trigger('click.open');
          this.resetKeyboard();
          return false;
        }
        // Ctrl + D (Duplicate)
        if (this.hasKeyboard(keyboards, 'D')) {
          const keyType = 'CLONE';
          $gryffEditor.trigger('handleshortcut.element', [keyType]);
          this.resetKeyboard();
          return false;
        }
        // Ctrl + L (Open Library)
        if (this.hasKeyboard(keyboards, 'L')) {
          app.$store.commit(`library/${mutations.TOGGLE}`, true);
          app.$store.commit(`library/${mutations.CHANGE_LAYOUT}`, 'default');
          this.resetKeyboard();
          return false;
        }
        if (this.hasKeyboard(keyboards, 'S')) {
          // Ctrl + S (Save)
          $divTopBar.find('#gf-save').trigger('click');
          this.resetKeyboard();
          return false;
        }
        if (this.hasKeyboard(keyboards, 'Z')) {
          // Ctrl + Z (Undo)
          $divTopBar.find('.gf_history-item[data-action="undo"]', parent.document).trigger('mousedown.undoandredo');
          this.resetKeyboard();
          return false;
        }
        // Ctrl + / (Keyboard Shortcuts)
        if (this.hasKeyboard(keyboards, '/')) {
          app.$store.commit('editor/SHOW_SHORTCUT_MODAL', true);
          this.resetKeyboard();
          return false;
        }
      }
      // Keep Shift
      // if (this.hasKeyboard(keyboards, "Shift")) {
      //   if(isHasPopupOpen) {
      //     return;
      //   }
      //   // Shift + / (Keyboard Shortcuts)
      //   if (this.hasKeyboard(keyboards, "/")) {
      //     app.$store.commit("editor/SHOW_SHORTCUT_MODAL", true);
      //     this.resetKeyboard();
      //     return false;
      //   }
      // }
      this.resetKeyboard();
      return false;
    };

    this.validateShortcuts = function (e) {
      // Keep Ctrl
      if (e.ctrlKey) {
        if (e.shiftKey && !this.hasKeyboard(keyboards, 'Shift')) {
          // Keep Ctrl + Shift
          keyboards.unshift(KEY_CODES['Shift']);
        }
        if (e.altKey && !this.hasKeyboard(keyboards, 'OptionAlt')) {
          // Keep Command + Shift
          keyboards.unshift(KEY_CODES['OptionAlt']);
        }
        if (!this.hasKeyboard(keyboards, 'Ctrl')) {
          keyboards.unshift(KEY_CODES['Ctrl']);
        }
      }
      // Keep Command
      if (e.metaKey) {
        if (e.shiftKey && !this.hasKeyboard(keyboards, 'Shift')) {
          // Keep Command + Shift
          keyboards.unshift(KEY_CODES['Shift']);
        }
        if (e.altKey && !this.hasKeyboard(keyboards, 'OptionAlt')) {
          // Keep Command + Shift
          keyboards.unshift(KEY_CODES['OptionAlt']);
        }
        if (!this.hasKeyboard(keyboards, 'Command')) {
          keyboards.unshift(KEY_CODES['Command']);
        }
      }

      // Keep Shift
      if (e.shiftKey) {
        if (!this.hasKeyboard(keyboards, 'Shift')) {
          keyboards.unshift(KEY_CODES['Shift']);
        }
      }

      if (keyboards.length === 0) {
        return false;
      }
      if (keyboards.length === 1) {
        if (
          this.hasKeyboard(keyboards, 'Command') ||
          this.hasKeyboard(keyboards, 'Ctrl') ||
          this.hasKeyboard(keyboards, 'OptionAlt') ||
          this.hasKeyboard(keyboards, 'Shift')
        ) {
          return false;
        }
      }
      return true;
    };

    this.hasKeyboard = function (pressedKeyCodes, keyCode) {
      return pressedKeyCodes.indexOf(KEY_CODES[keyCode]) !== -1;
    };

    this.blockKeyboardBrowser = function (e) {
      if ((e.ctrlKey && e.shiftKey) || (e.metaKey && e.shiftKey)) {
        // case đang sử dụng keep (ctrl || command) and shift
        const KEY_CODES_CTRL_SHIFT = [KEY_CODES['Z'], KEY_CODES['S']];
        if (KEY_CODES_CTRL_SHIFT.includes(e.which)) {
          return true;
        }
        return false;
      }
      if ((e.ctrlKey && e.altKey) || (e.metaKey && e.altKey)) {
        // case đang sử dụng keep (ctrl || command) and (alt || option)
        const KEY_CODES_CTRL_ALT = [KEY_CODES['C'], KEY_CODES['V']];
        if (KEY_CODES_CTRL_ALT.includes(e.which)) {
          return true;
        }
        return false;
      }
      if (e.ctrlKey || e.metaKey) {
        // các case đang sử dụng keep ctrl
        const KEY_CODES_CTRL = [
          KEY_CODES['S'],
          KEY_CODES['D'],
          KEY_CODES['B'],
          KEY_CODES['I'],
          KEY_CODES['U'],
          KEY_CODES['L'],
          KEY_CODES['/'],
        ];
        if (KEY_CODES_CTRL.includes(e.which)) {
          return true;
        }
        return false;
      }
      // if(e.shiftKey) {
      //   // các case đang sử dụng keep Shift
      //   const KEY_CODES_SHIFT = [
      //     KEY_CODES["/"]
      //   ]
      //   if(KEY_CODES_SHIFT.includes(e.which)) {
      //     return true
      //   }
      //   return false;
      // }
      return false;
    };

    this.hasUsingKeyboardShortcut = function (e) {
      if (e.which == KEY_CODES['/']) {
        return true;
      }
      return app?.$store?.state?.app?.shopInfo?.storeInfo?.shortcut;
    };

    this.hasKeyPressed = function (key) {
      return pressedKeys[KEY_CODES[key]] || false;
    };

    this.resetKeyboard = function (key) {
      keyboards = [];
      return false;
    };

    this.helperCheckAndHandleShortcut = function (isOnlyClosePopup = false, isOnlyCheckExistsPopup = false) {
      const isOpenningFontManager = app.$store.getters['font/showFontManager'];
      if (isOpenningFontManager) {
        if (!isOnlyClosePopup && !isOnlyCheckExistsPopup) {
          app.$store.dispatch('font/openFontManager', false);
        }
        return true;
      }

      const $divContentHidden = jQuery('#divContentHidden');
      const $gfLeftSideBar = jQuery('#gfLeftSideBar');
      const $mdSettings = $gfLeftSideBar.find('#md-settings');
      let isHandleDonePopupNotOverfley = false;
      // -------------------------Nếu đang mở tooltips View Live => Close-----------------------------=
      const $gfTooltipsNew = $shopLaunch.find('#gfTooltipsNew');
      if ($gfTooltipsNew.length > 0 && $gfTooltipsNew.html()) {
        // Đối với trường hợp không có overlay thì close và handle shortcut action (không check `isOnlyCheckExistsPopup`)
        $gfTooltipsNew.find('.gfTooltipsItemClose').trigger('click');
        isHandleDonePopupNotOverfley = true;
      }
      // -------------------------Nếu đang mở dropdown list more => Close------------------------------
      const $actionItemMore = $divTopBar.find('.gf_action-item--more');
      if ($actionItemMore.length > 0 && $actionItemMore.hasClass('active')) {
        $actionItemMore.trigger('click');
        isHandleDonePopupNotOverfley = true;
      }

      if ($mdSettings && $mdSettings.hasClass('active')) {
        if ($mdSettings.find('.dropdown-group').css('display') == 'block') {
          $mdSettings.find('.tab-action-icon').trigger('click');
          isHandleDonePopupNotOverfley = true;
          return false;
        }
        if ($mdSettings.find('.tab-action-dropdown').css('display') == 'block') {
          $mdSettings.find('.tab-action-icon.active').trigger('click');
          isHandleDonePopupNotOverfley = true;
          return false;
        }
      }
      if (isHandleDonePopupNotOverfley) {
        return false;
      }
      // -------------------------Nếu đang bật Library || Export Library => Close---------------------
      const isOnLibrary = app?.$store?.state?.library?.active;
      if (isOnLibrary) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        app.$store.commit(`library/${mutations.TOGGLE}`, false);
        return false;
      }
      // -------------------------Nếu đang bật Shortcut Modal => Close------------------------------
      const isShowShortcutModal = app?.$store?.state?.editor?.showShortcutModal;
      if (isShowShortcutModal) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        app.$store.commit('editor/SHOW_SHORTCUT_MODAL', false);
        return false;
      }
      // -------------------------Nếu đang bật Modal Page Seting------------------------------
      const isOnPageSetting = app?.$store?.state?.app?.showPageSettingModal;
      if (isOnPageSetting) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        app.$store.commit('app/SHOW_PAGE_SETTING_MODAL', false);
        app.$store.commit('app/DISABLE_HISTORY_ITEM', false);
        return false;
      }
      // -------------------------Nếu đang mở popup Edit Code => Close------------------------------
      const $mdEditor = $divContentHidden.find('#md-editor');
      if ($mdEditor.length > 0 && $mdEditor.hasClass('md-show')) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $mdEditor.find('.md-footer button.btnSave').trigger('click');
        return false;
      }

      // -------------------------Nếu đang mở popup Publish => Close------------------------------
      const $pageConfirmPublish = $divContentHidden.find('#md-page-confirm-publish');
      if ($pageConfirmPublish && $pageConfirmPublish.hasClass('show')) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $divContentHidden.find('.fake_publish.btn.btn-primary').trigger('click');
        return false;
      }
      // -------------------------Nếu đang mở popup Upgrade Plan Modal => Close----------------------
      const $upgradePlanModal = $shopLaunch.find('.gf_upgrade-plan-modal');
      if ($upgradePlanModal.length > 0) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $upgradePlanModal.find('.gf_upgrade-plan-modal--close').trigger('click');
        return false;
      }
      // -------------------------Nếu đang mở popup Schedule Publish => close---------------------------
      const $schedulePublishModal = $shopLaunch.find('.gf_schedule-publish');
      if ($schedulePublishModal.length > 0) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $schedulePublishModal.find('.gf_schedule-publish--close').trigger('click');
        return false;
      }
      // -------------------------Popup nằm trong setting của sidebar và có overflay----------------------
      const $mdPhotoPicker = $divContentHidden.find('#md-photo-picker');
      if ($mdPhotoPicker.length > 0 && $mdPhotoPicker.find('.gf_modal').hasClass('gf_modal-show')) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $mdPhotoPicker.find('.gf_modal').removeClass('gf_modal-show');
        return false;
      }

      const $mdIconPicker = $divContentHidden.find('#md-icon-picker');
      if ($mdIconPicker.length > 0 && $mdIconPicker.find('.gf_modal').hasClass('gf_modal-show')) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $mdIconPicker.find('.gf_modal').removeClass('gf_modal-show');
        return false;
      }

      const $mdProductSelector = $divContentHidden.find('#md-product-selector');
      if ($mdProductSelector.length > 0 && $mdProductSelector.find('.gf_modal').hasClass('gf_modal-show')) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $mdProductSelector.find('.gf_modal').removeClass('gf_modal-show');
        return false;
      }

      const $mdFontManager = $divContentHidden.find('#md-font-manager');
      if ($mdFontManager.length > 0 && $mdFontManager.find('.gf_modal').hasClass('gf_modal-show')) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $mdFontManager.find('.gf_modal .gf_modal-btnCancel').trigger('click');
        $mdFontManager.find('.gf_modal').removeClass('gf_modal-show');
        return false;
      }

      const $mdSwatchesEditor = $divContentHidden.find('#md-swatches-editor');
      if ($mdSwatchesEditor.length > 0 && $mdSwatchesEditor.find('.gf_modal').hasClass('gf_modal-show')) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $mdSwatchesEditor.find('.gf_modal').removeClass('gf_modal-show');
        return false;
      }

      const $mdCollectionSelector = $divContentHidden.find('#md-collection-selector');
      if ($mdCollectionSelector.length > 0 && $mdCollectionSelector.find('.gf_modal').hasClass('gf_modal-show')) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $mdCollectionSelector.find('.gf_modal').removeClass('gf_modal-show');
        return false;
      }
      const $mdLinkPicker = $divContentHidden.find('#md-link-picker');
      if ($mdLinkPicker.length > 0 && $mdLinkPicker.find('.gf_modal').hasClass('gf_modal-show')) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $mdLinkPicker.find('.gf_modal .gf_modal-btnCancel').trigger('click');
        $mdLinkPicker.find('.gf_modal').removeClass('gf_modal-show');
        return false;
      }
      const $mdEditorColor = jQuery('#md-editor-color');
      if ($mdEditorColor.length > 0 && $mdEditorColor.hasClass('active')) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $mdEditorColor.removeClass('active');
        return false;
      }
      const $mdEditorLink = jQuery('#md-editor-link');
      if ($mdEditorLink.length > 0 && $mdEditorLink.hasClass('show')) {
        if (isOnlyCheckExistsPopup) {
          return true;
        }
        $mdEditorLink.removeClass('show');
        return false;
      }
      // ------------------------------------------------------------------------------------------------

      if ($mdSettings && $mdSettings.hasClass('active')) {
        const $columnsAdvanced = $mdSettings.find('.columns-advanced');
        if ($columnsAdvanced.length > 0 && $columnsAdvanced.css('display') == 'block') {
          // Case này cho phép nằm đè popup
          if (isOnlyCheckExistsPopup) {
            return false;
          }
          $columnsAdvanced.css('display', 'none');
          return false;
        }
      }
      // -------------Nếu đang show text editor mà mở lable thì đóng tool text editor (Tool B/U/I)-------
      const $mdTextEditor = jQuery('#md-text-editor');
      const isShowMdTextEditor = $mdTextEditor && $mdTextEditor.hasClass('show');
      if (isShowMdTextEditor) {
        if (
          !this.hasKeyboard(keyboards, 'B') &&
          !this.hasKeyboard(keyboards, 'I') &&
          !this.hasKeyboard(keyboards, 'U')
        ) {
          $mdTextEditor.removeClass('show');
          return;
        }
      }

      if (isOnlyClosePopup) {
        if (isOnlyCheckExistsPopup) {
          return false;
        }
        return;
      }
      // -------------Nếu đang Open Setting Sider Bar => Close------------------------------
      if ($mdSettings && $mdSettings.hasClass('active')) {
        $mdSettings.find('button.back-to-snippets').trigger('click');
        return;
      }
      // -------------Nếu đang filter snippets => Reset input------------------------------
      const $gfModalFilter = $gfLeftSideBar.find('.gfModalFilter');
      if ($gfModalFilter.find("input[name='snippet-filter']").val()) {
        $gfModalFilter.find('.modal-search').find('*').trigger('mousedown.clearSearch');
      }
    };

    this.checkIsInputting = function () {
      const documentIframe = document.getElementById('gfFrame').contentWindow.document;
      const isActiveInput = $(document.activeElement).is('input') || $(documentIframe.activeElement).is('input');
      const isActiveTextArea =
        $(document.activeElement).is('textarea') || $(documentIframe.activeElement).is('textarea');
      return isActiveInput || isActiveTextArea;
    };

    this.init();
  };

  jQuery.fn.gfShortcut = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfShortcut')) {
        const plugin = new jQuery.gfShortcut(this, options);
        jQuery(this).data('gfShortcut', plugin);
      }
    });
  };
})(jQuery);
